import { Alert, Button, Col, Form, Input, Row, Typography } from 'antd'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { LoginHand } from '../../store/Auth/LoginSlice'
import useTranslation from '../../localization/useTranslation'
import LanguageToggler from '../../components/LanguageToggler/LanguageToggler'

const LogIn = () => {
    const dispatch = useDispatch()
    const { loading, error } = useSelector((state) => state.login)
    const [from] = Form.useForm()
    const { t, language } = useTranslation()

    const onFinish = (values) => {
        dispatch(LoginHand(values))
    }

    return (
        <>
            {error ? <Alert message={error} type="error" showIcon closable style={{ marginBottom: 16 }} /> : null}

            <Row style={{ height: "100vh", position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {/* positioned toggler in the corner */}
                <div style={{ position: 'absolute', top: 12, right: 12, zIndex: 1000 }}>
                    <LanguageToggler variant="round" />
                </div>

                <div style={{ width: 420, maxWidth: '92%', padding: 20, boxSizing: 'border-box' }}>
                    <div style={{ textAlign: 'center', marginBottom: 8 }}>
                        <Typography.Title style={{ marginBottom: 8 }}>{t('auth.login.title')}</Typography.Title>
                    </div>

                    <div>
                        <Form dir={language === 'ar' ? 'rtl' : 'ltr'} form={from} onFinish={onFinish} labelCol={{ span: 24 }}>
                            <Form.Item
                                name='email'
                                label={t('auth.login.email.label')}
                                rules={[
                                    {
                                        required: true,
                                        message: t('auth.login.email.required'),
                                    },
                                    {
                                        type: 'email',
                                        message: t('auth.login.email.invalid'),
                                    },
                                ]}
                            >
                                <Input type='email' placeholder={t('auth.login.email.placeholder')} />
                            </Form.Item>
                            <Form.Item
                                name='password'
                                label={t('auth.login.password.label')}
                                rules={[
                                    {
                                        required: true,
                                        message: t('auth.login.password.required'),
                                    },
                                ]}
                            >
                                <Input.Password placeholder={t('auth.login.password.placeholder')} />
                            </Form.Item>
                            <Form.Item>
                                <Button block type="primary" htmlType="submit" loading={loading}>
                                    {t('auth.login.submit')}
                                </Button>
                            </Form.Item>
                            <Form.Item style={{ marginBottom: 0, textAlign: 'center' }}>
                                <Link to="/forgot-password">{t('auth.login.forgotPassword')}</Link>
                            </Form.Item>
                        </Form>
                    </div>
                </div>
            </Row>
        </>
    )
}

export default LogIn
